import request from '@/utils/request_python'

export function get_report_detail_expansion(
  start_date,
  end_date,
  empr_id,
  usua_id
) {
  const data = {
    start_date,
    end_date,
    empr_id,
    usua_id
  }
  return request({
    url: '/sync/expansion/detail',
    method: 'get',
    timeout: 900000,
    params: data,
    responseType: 'blob'
  })
}

export function get_report_modernizacion(
  start_date,
  end_date,
  empr_id,
  usua_id
) {
  const data = {
    start_date,
    end_date,
    empr_id,
    usua_id
  }
  return request({
    url: '/sync/modernizacion',
    method: 'get',
    timeout: 900000,
    params: data,
    responseType: 'blob'
  })
}

export function get_inventario_ucap_luminaria(fecha_corte, empr_id, usua_id) {
  const data = {
    fecha_corte,
    empr_id,
    usua_id
  }
  return request({
    url: '/sync/inventario/ucap/luminaria',
    method: 'get',
    timeout: 900000,
    params: data,
    responseType: 'blob'
  })
}
